/**
 * Resolve a storage path or remote URL into a browser-loadable preview URL.
 *
 * @param {string|null|undefined} value
 * @param {string} [diskUrl]
 * @returns {string|null}
 */
export function resolveStorageUrl(value, diskUrl = '') {
    if (!value) {
        return null
    }

    if (/^(https?:|data:|blob:)/i.test(value)) {
        try {
            const parsed = new URL(value)

            if (parsed.origin !== window.location.origin) {
                return `${window.location.origin}${parsed.pathname}${parsed.search}`
            }

            return value
        } catch {
            return value
        }
    }

    if (value.startsWith('/')) {
        return `${window.location.origin}${value}`
    }

    const base = diskUrl.replace(/\/$/, '')

    return base ? `${base}/${value.replace(/^\//, '')}` : value
}

/**
 * Revoke a blob preview URL when it is no longer needed.
 *
 * @param {string|null|undefined} url
 */
export function revokeObjectUrl(url) {
    if (url && url.startsWith('blob:')) {
        URL.revokeObjectURL(url)
    }
}
